// Constants
import { CASE_TYPES } from './general'

const OPTIONS = {
  [CASE_TYPES.GENERAL]: [
    'Show my schedule',
    'Show my list',
    'Create a <note type>',
    'Create a note',
    'Go to unfinished notes',
    'Log out',
    'Help',
    'Go back',
    'Go home',
    'Go to settings',
    'Show my scripts',
    'Show my note types'
  ],
  [CASE_TYPES.NOTE]: [
    '<section name>',
    'Undo',
    'Delete sentence',
    'Stop',
    "I'm done",
    'Print note',
    'Delete note',
    'Insert <script name>',
    'Change <field name>',
    'Copy forward <section name>',
    'Patient name is <patient name>'
  ],
  [CASE_TYPES.AMWELL]: [
    '<section name>',
    'Stop',
    'Show my scripts',
    'Insert <script name>',
    'Change <field name>',
    'Undo',
    'Delete sentence'
  ]
}

export default OPTIONS
